import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_PROJECTS_LIST, GET_PROJECTS_LIST_SUCCESS, GET_PROJECTS_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getProjectsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/projects`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        getAll: true,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROJECTS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROJECTS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROJECTS_LIST_ERROR, payload: error });
  }
}

export function* watchProjectsList() {
  yield takeEvery(GET_PROJECTS_LIST, getProjectsList);
}

function* projectsListSaga() {
  yield all([fork(watchProjectsList)]);
}

export default projectsListSaga;
